export default {
  home: 'HOME',
  courseCenter: 'COURSE_CENTER',
  courseDetail: 'COURSEDETAIL',
  personCenter: 'PERSON_CENTER',
  myCourse: 'MY_COURSE',
  myCourse_v1: 'MY_COURSE_V1',
  register: 'REGISTER',
  teacherLogin: 'TEACHER_LOGIN',
  word_test: 'word_test',
  course_video: 'course_video',
  famous_read: 'famous_read'
}
